import './styles/InputDateTime.css';

import { Input } from '@chakra-ui/react';
import moment from 'moment';
import { useCallback, useEffect } from 'react';

import {
	defineBorderColorValue,
	defineInputValue,
} from './constants/inputsControl';
import { setInputsWithLocalstorage } from './constants/setInputsWithLocalstorage';
import { IInputs } from './models/InputsModel';

export const InputDateTime = ({ ...others }: IInputs) => {
	const {
		dataTest,
		column,
		handleOnChange,
		inputValue,
		name,
		setInputValue,
		validation,
		localStorageValue,
	} = others;

	useEffect(() => {
		setInputsWithLocalstorage({
			column,
			localStorageValue,
			name,
			setInputValue,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getMaxDate = useCallback(() => {
		const today = moment();
		const maxDate = today.add(1, 'year').format('YYYY-MM-DD HH:mm');
		return maxDate;
	}, []);

	return (
		<Input
			data-test={dataTest}
			className='input-datetime'
			type={'datetime-local'}
			borderRadius={'10px'}
			borderColor={defineBorderColorValue({
				name,
				validation,
			})}
			focusBorderColor='#e2e8f0'
			h={'3em'}
			fontSize={'12px'}
			name={name}
			onChange={event => handleOnChange(event)}
			value={defineInputValue({
				name,
				inputValue,
			})}
			max={getMaxDate()}
		/>
	);
};
